import { Modal } from 'bootstrap';
import { _addCsrfToken, notyf } from "../../app/helpers";

const deleteFolderBtn = document.querySelectorAll('.js--btn_delete');
const deletePublicationFromFolderBtn = document.querySelectorAll('.js--delete_post');
const editFolderBtn = document.querySelectorAll('.js--btn_edit');
const modalConfirm = document.getElementById('confirmDeleteModal');
let targetButton;

if (deleteFolderBtn.length) {
  deleteFolderBtn.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      targetButton = event.target.closest('.js--btn_delete');
      const confirmModal = new Modal(document.getElementById('confirmDeleteModal'));
      confirmModal.show();
    });
  });

  document.querySelector('.js--confirm-delete').addEventListener('click', () => {
    const url = targetButton.dataset.url || '/cabinet/delete-folder';
    const formData = new FormData();
    formData.append('id', targetButton.getAttribute("data-id"));
    _addCsrfToken(formData);
    const headers = new Headers({
      'X-Requested-With': 'XMLHttpRequest',
    });
    fetch(url, {
      method: "POST",
      headers: headers,
      body: formData,
    })
        .then(response => response.json())
        .then(data => {
          let success = data.success ?? false;
          let notyfType = success ? 'success' : 'error';
          let delay = 2000;

          if (data.message) {
            notyf[notyfType](data.message).on('dismiss', ({target, event}) => {
              if (data.url) {
                window.location.href = data.url;
              } else {
                window.location.reload()
              }
            });
          }

          if (data.url) {
            setTimeout(() => window.location.href = data.url, delay);
          } else {
            setTimeout(() => window.location.reload(), delay);
          }

        })
        .catch((err) => console.error(err));

    const confirmModal = Modal.getInstance(document.getElementById('confirmDeleteModal'));
    confirmModal.hide();
  });
}

if (deletePublicationFromFolderBtn.length && modalConfirm) {
  deletePublicationFromFolderBtn.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      targetButton = event.target.closest('.js--delete_post');
      const confirmModal = new Modal(modalConfirm);
      confirmModal.show();
    });
  });

  document.querySelector('.js--confirm-delete').addEventListener('click', () => {
    const url = targetButton.dataset.url;
    const formData = new FormData();
    formData.append('id', targetButton.getAttribute("data-id"));
    _addCsrfToken(formData);
    const headers = new Headers({
      'X-Requested-With': 'XMLHttpRequest',
    });
    fetch(url, {
      method: "POST",
      headers: headers,
      body: formData,
    })
        .then(response => response.json())
        .then(data => {
          let success = data.success ?? false;
          let notyfType = success ? 'success' : 'error';
          let delay = 2000;

          if (data.message) {
            notyf[notyfType](data.message).on('dismiss', ({target, event}) => {
              if (data.url) {
                window.location.href = data.url;
              } else {
                window.location.reload();
              }
            });
          }

          if (data.url) {
            setTimeout(() => window.location.href = data.url, delay);
          } else {
            setTimeout(() => window.location.reload(), delay);
          }

        })
        .catch((err) => console.error(err));

    const confirmModal = Modal.getInstance(document.getElementById('confirmDeleteModal'));
    confirmModal.hide();
  });
}

if (editFolderBtn.length) {
  editFolderBtn.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      const idFolder = parseInt(btn.getAttribute("data-id"), 10);
      const folderName = btn.getAttribute("data-name");
      const folderDescript = btn.getAttribute("data-description");
      const editModal = document.getElementById("editFolderModal");

      const folderNameInput = editModal.querySelector('.js--folder-name');
      const folderDescrInput = editModal.querySelector('.js--folder-description');
      const folderIdInput = editModal.querySelector('.js--folder-id');

      if (folderNameInput) {
        editModal.querySelector('.js--folder-name').value = folderName;
      }

      if (folderDescrInput) {
        editModal.querySelector('.js--folder-description').value = folderDescript;
      }

      if (folderIdInput) {
        editModal.querySelector('.js--folder-id').value = idFolder;
      }

      editModal.setAttribute("data-id", idFolder);

      const modal = new Modal(editModal);
      modal.show();

      event.preventDefault();
    });
  });
}

